<template>
    <li>
        <a class="stockitem" :href="subdirectory+'/truck/'+slug" :title="'meer info over: ' + merk + ' ' + type + ' ' + model">
            <a href="#" class="favorite" :class="{active: isFavorite(id)}" title="toevoegen aan favorieten" @click.prevent="setAsFavorite(id)"></a>
            <div class="overlay">
                <div class="buttons">
                    <div class="button blue">{{ translations.meer_info }}</div>
                    <a :href="video" class="button black" v-if="video" data-fancybox>{{ translations.bekijk_video }}</a>
                </div>
            </div>
            <div class="image" :style="{ backgroundImage: 'url(' + image + ')' }"></div>
            <div class="content">
                <span class="large"> {{ merk }} {{ model }} {{ type }} </span>
                <div class="specs">
                    <div v-if="voertuignr_klant">{{ translations.Referentienummer }}:
                        <span>{{ voertuignr_klant }}</span>
                    </div>
                    <div v-if="reg_year">{{ translations.registratie }}:
                        <span>{{ reg_year }}</span>
                    </div>
                    <div v-if="vermogen_motor_pk && vermogen_motor_pk !== '0'">{{ translations.Vermogen }}:
                        <span>{{ vermogen_motor_pk }} pk</span>
                    </div>
                    <div v-if="tellerstand">{{ translations.Kilometerstand }}:
                        <span>{{ tellerstand | number }} km</span>
                    </div>
                </div>
                <span class="large price" v-if="price > 0">&euro; {{ price | number }},-</span>
                <span class="large price" v-else>{{ translations.Prijs_op_aanvraag }}</span>
            </div>
        </a>
    </li>
</template>

<script>
import { EventBus } from '../../event-bus.js'

export default {
    props: {
        id: [Number, String],
        merk: String,
        type: String,
        model: String,
        voertuigsoort: String,
        voertuignr_klant: String,
        tellerstand: String,
        reg_year: String,
        vermogen_motor_pk: String,
        image: String,
        price: String,
        video: String,
        subdirectory: String,
        slug: String,
        translations: {}
    },
    data() {
        return {
            favorites: this.$ls.get('favorites')
        }
    },
    methods: {
        isFavorite(id) {
            return _.includes(this.favorites, id)
        },
        setAsFavorite(id) {
            let favorites = this.$ls.get('favorites', []),
                index = favorites.indexOf(id)

            index === -1 ? favorites.push(id) : favorites.splice(index, 1)

            this.favorites = favorites
            this.$ls.set('favorites', favorites)
            EventBus.$emit('setFavorites')
        }
    }
}
</script>
